import { render, staticRenderFns } from "./DepotList.vue?vue&type=template&id=9b139fe8&scoped=true"
import script from "./DepotList.vue?vue&type=script&lang=js"
export * from "./DepotList.vue?vue&type=script&lang=js"
import style0 from "./DepotList.vue?vue&type=style&index=0&id=9b139fe8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b139fe8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b139fe8')) {
      api.createRecord('9b139fe8', component.options)
    } else {
      api.reload('9b139fe8', component.options)
    }
    module.hot.accept("./DepotList.vue?vue&type=template&id=9b139fe8&scoped=true", function () {
      api.rerender('9b139fe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/DepotList.vue"
export default component.exports